// @sheerid/jslib doesn't polyfill for IE11 currently
import 'whatwg-fetch';
import 'url-search-params-polyfill';

import * as React from 'react';
import * as ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';

// SheerID stuff
import { setOptions, overrideComponent } from '@sheerid/jslib';
import { defaultOptions } from './programOptions';
import { googleTagManagerHook, ipqsHook } from './hooks/hooks';
import { StepStudentPersonalInfoComponent } from './components/stepComponents/StepStudentPersonalInfo/StepStudentPersonalInfoComponent';
import { StepSuccessComponent } from './components/stepComponents/StepSuccess/StepSuccessComponent';
import { StepDocUploadComponent } from './components/stepComponents/StepDocUpload/StepDocUploadComponent';

setOptions(defaultOptions);
googleTagManagerHook();
ipqsHook();

declare global {
    interface Window {
        Startup: any;
        IPQ: any;
    }
}

// @ts-ignore
overrideComponent('StepStudentPersonalInfoComponent', StepStudentPersonalInfoComponent);
// @ts-ignore
overrideComponent('StepSuccessComponent', StepSuccessComponent);
// @ts-ignore
overrideComponent('StepDocUploadComponent', StepDocUploadComponent);

ReactDOM.render(<App />, document.getElementById('root'));

serviceWorker.unregister();
